import { Component, OnInit } from '@angular/core';
import { ABCisApi, ApiService } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-store-supplier-selector',
  standalone: false,
  templateUrl: './store-supplier-selector.component.html',
  styleUrls: ['./store-supplier-selector.component.scss']
})
export class StoreSupplierSelectorComponent implements OnInit {

  selectedStoreId: Array<number> = [];
  selectedSupplierId: Array<number> = [];
  globalSupplierStoreMapId: any;

  constructor(private apiHandler: ApiService) { }

  ngOnInit(): void {
  }

  storeSelectChange(storeResponse: Array<number>) {
    this.selectedStoreId = storeResponse;
    if (storeResponse.length === 0) {
      this.selectedStoreId = [];
    }
    this.enableAddButtonIfValid();
  }

  supplierSelectChange(supplierResponse: Array<number>) {
    this.selectedSupplierId = supplierResponse;
    if (supplierResponse.length === 0) {
      this.selectedSupplierId = [];
    }
    this.enableAddButtonIfValid();
  }

  enableAddButtonIfValid() {
    const addButton = document.querySelector('button[label="Add"]');
    console.log('selectedStoreId: '+this.selectedStoreId);
    console.log('selectedSupplierId: '+this.selectedSupplierId);
    if (this.selectedStoreId.length == 1 && this.selectedSupplierId.length == 1) {
      // check if have existing global supplier store map id
      this.apiHandler.getABCisRequest(ABCisApi.Support, `global-supplier-store-map/${this.selectedStoreId}/${this.selectedSupplierId}`).then(httpResponse => {
        if (httpResponse.body) {
          this.globalSupplierStoreMapId = httpResponse.body;
          addButton.removeAttribute('disabled');
          addButton.removeAttribute('title');
        } else {
          addButton.setAttribute('disabled', 'true');
          addButton.setAttribute('title', 'No Global Supplier Store Map ID Found');
        }
      });
    } else {
      addButton.setAttribute('disabled', 'true');
      addButton.removeAttribute('title');
    }
  }

  onSearchClick() {
    console.log('On search triggerred...');
  }
}
